import { withTranslation } from "next-i18next";

function ValidationSubheader({ t }) {
  return (
    <div className="p-3 bg-white">
      <div className="px-3">
        <h5 className="text-center mb-2">
          {t("common:drawer.modal_rtc.validate.title")}
        </h5>

        <p className="text-center text-gray mb-0">
          {t("common:drawer.modal_rtc.validate.subtitle")}
        </p>
      </div>
    </div>
  );
}

export default withTranslation("common")(ValidationSubheader);
